import { MealCountDtoViewModel } from "@/view-models";
import { MealCountDto, ReceivedMeals, ServingLine, ProgramType, MealCountCalcs, SiteInfo, SponsorInfo, ProgramInfo } from '@/models';
import { Guid } from 'guid-typescript';
import { UserInfo } from '@/store';
import moment from 'moment';

let date = moment.utc().format();
let testReceivedMeals = new ReceivedMeals('2020-02-10', 10, 100, 11, 1, 1, 'Test', 'User', date, date);
let testServingLine = new ServingLine(
    Guid.create().toString(),
    1,
    2,
    3,
    4,
    1,
    1,
    1,
    1,
    0,
    true,
    1,
    'Test',
    'User',
    date,
    date);

let testCounts = new MealCountDto(
    Guid.create().toString(),
    1,
    ProgramType.SFSP,
    'LUNCH',
    '2020-02-14',
    date,
    false,
    0,
    testReceivedMeals,
    [ testServingLine ]);

let calcCounts = new MealCountCalcs(testCounts);

let model = new MealCountDtoViewModel(testCounts);

export let data = {
    testReceivedMeals: testReceivedMeals,
    testServingLine: testServingLine,
    testCounts: testCounts,
    calcCounts: calcCounts,
    model: model,
    appUser: new UserInfo('', 1, 'a'),
    sites: [ new SiteInfo(1, '001', 1, '001', 'Test Site') ],
    sponsors: [ new SponsorInfo(1, '001', 'Test Sponsor') ],
    programs: [ new ProgramInfo(ProgramType[ProgramType.SFSP], '', '', true, false) ],
    siteAppDates: []
}
